import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConstants } from "src/app/app.constants";
import { catchError } from "rxjs/operators";
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class LitigationInformationService {
  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService
  ) {}

  /**
   * payload = {
   *   "NDA Number": "211150",
   *   "Brand Name": "WAKIX"
   * }
   */
  getLitigationData(payload: {
    "NDA Number": string;
    "Brand Name": string;
  }): Observable<any> {
    return this.http
      .post<any>(
        `${AppConstants.API_ENDPOINT1}${AppConstants.API.SECTION_API.LITIGATION_INFORMATION}`,
        payload
      )
      .pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getOtherLitigationData(payload: {
    "NDA Number": string;
    "Brand Name": string;
  }): Observable<any> {
    return this.http
      .post<any>(
        `${AppConstants.API_ENDPOINT1}${AppConstants.API.SECTION_API.OTHER_LITIGATION_INFORMATION}`,
        payload
      )
      .pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
